var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_594_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 6.99996C17.0567 6.99996 19.6933 9.16996 20.2883 12.1683L20.6383 13.9183L22.4233 14.0466C23.3004 14.1056 24.1225 14.4946 24.7243 15.1353C25.326 15.7761 25.6627 16.621 25.6667 17.5C25.6667 19.425 24.0917 21 22.1667 21H7C4.42167 21 2.33333 18.9116 2.33333 16.3333C2.33333 13.9416 4.11833 11.9466 6.48667 11.7016L7.735 11.5733L8.31833 10.465C8.85486 9.42053 9.66918 8.54441 10.6716 7.93305C11.6741 7.3217 12.8258 6.99881 14 6.99996ZM14 4.66663C10.6283 4.66663 7.7 6.57996 6.24167 9.37996C4.52694 9.56526 2.94117 10.3777 1.78907 11.6612C0.636966 12.9446 -0.000200319 14.6086 4.72415e-08 16.3333C4.72415e-08 20.195 3.13833 23.3333 7 23.3333H22.1667C25.3867 23.3333 28 20.72 28 17.5C28 14.42 25.6083 11.9233 22.575 11.7133C22.1831 9.7273 21.1139 7.93896 19.5499 6.65375C17.9859 5.36853 16.0243 4.66617 14 4.66663Z",
    fill: "#674366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_594_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceThree);
export default __webpack_public_path__ + "static/media/serviceThree.d377eeb4697fd4546bdf695277650918.svg";
export { ForwardRef as ReactComponent };